import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Bank } from '@gcv/shared';
import { BankActionTypes } from './bank.actions';

export interface BankState extends EntityState<Bank> {
  partialBank: Partial<Bank>;
}

export const adapterBank: EntityAdapter<Bank> = createEntityAdapter<Bank>();

export const initialBankState = adapterBank.getInitialState({ partialBank: null });

export function bankReducer(state = initialBankState, action): BankState {
  switch (action.type) {
    case BankActionTypes.BankLoaded:
      return adapterBank.upsertOne(action.payload, state);
    case BankActionTypes.BankPartialLoaded:
      return {
        ...state,
        partialBank: action.payload,
      };
    case BankActionTypes.BankUpdated:
      return adapterBank.updateOne({ id: action.payload.id, changes: action.payload }, state);
    case BankActionTypes.DispensaryAddedToBank:
      return adapterBank.updateOne({ id: action.payload.id, changes: action.payload }, state);
    case BankActionTypes.DispensaryRemovedFromBank:
      return adapterBank.updateOne({ id: action.payload.id, changes: action.payload }, state);
    case BankActionTypes.BankCreated:
      return adapterBank.addOne(action.payload, state);
    case BankActionTypes.AllBanksLoaded:
      return adapterBank.addMany(action.payload, state);
    case BankActionTypes.GroupsUpdated:
      return adapterBank.updateOne({ id: action.payload.id, changes: action.payload }, state);
    case BankActionTypes.BankGCVDueDiligenceStatusUpdated:
      return adapterBank.updateOne({ id: action.payload.id, changes: action.payload }, state);
    case BankActionTypes.ResetBank:
      return initialBankState;
    default:
      return state;
  }
}

export const {
  selectIds: selectBankIds,
  selectEntities: selectBankEntities,
  selectAll: selectAllBanks,
} = adapterBank.getSelectors();
